var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1358 1.0225C14.6697 1.72333 16.6793 4.00034 17.4517 5.87094C18.2241 7.74153 18.3486 9.81672 17.8054 11.7663C17.2623 13.7158 16.0826 15.4276 14.4542 16.6293C12.8259 17.831 10.8423 18.4536 8.81933 18.3978C6.79631 18.3421 4.85006 17.6113 3.29033 16.3218C1.73059 15.0322 0.646994 13.258 0.21199 11.2815C-0.223014 9.30506 0.0155723 7.23987 0.889778 5.41464C1.76398 3.58941 3.68256 1.6329 6.30477 1.0225L6.30477 3.76419C5.06227 4.38105 4.06179 5.39579 3.46256 6.64689C2.86334 7.898 2.6998 9.31359 2.99797 10.6684C3.29614 12.0232 4.0389 13.2393 5.10802 14.1232C6.17715 15.0071 7.51121 15.508 8.89789 15.5462C10.2846 15.5844 11.6442 15.1577 12.7604 14.334C13.8765 13.5103 14.6851 12.3369 15.0574 11.0006C15.4297 9.66431 15.3444 8.24187 14.815 6.95966C14.2855 5.67746 13.3424 4.60918 12.1358 3.92484V1.0225Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.60645,
    width: 2.92614,
    height: 7.50731,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f9d8bb0d.svg";
export { ForwardRef as ReactComponent };